import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'myj';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <Row>
          <Col sm="6" style={{ margin: '0', padding: '0' }}>
            <div className="myj-right">
              <img src={logo} alt="logo" className="logo-myj rounded mx-auto d-block" />
              <br />
              <div className='myj-title'>
                <span >Go Turner</span>
              </div>
            </div>
          </Col>
          <Col sm="6" style={{ margin: '0', padding: '0' }}>
            <div className="myj-left">
              <div className="login-myj-container">
                <Form onSubmit={(event) => onSubmit(event)}>
                  <Container fluid={true} className="myj-form-container">
                    <Row className="myj-form-body">
                      <Col sm="12" xs="12" md="12" className="myj-input">
                        <Input
                          className="user-input-myj"
                          disabled={onLogin}
                          required={true}
                          tabIndex={1}
                          type="text"
                          autoCorrect="off"
                          autoCapitalize="none"
                          id="username"
                          placeholder={translate("PlaceholderUserName")}
                          onChange={e => setUsername(e.target.value)}
                        />
                      </Col>
                      <Col sm="12" xs="12" md="12" className="myj-input">
                        <Input
                          className="pass-input-myj"
                          required={true}
                          disabled={onLogin}
                          tabIndex={1}
                          type="password"
                          autoCorrect="off"
                          autoCapitalize="none"
                          id="password"
                          placeholder={translate("PlaceholderPassword")}
                          onChange={e => setPassword(e.target.value)}
                        />
                      </Col>
                      <Col sm="12" xs="12" md="12" className="myj-input">
                        {!onLogin ? (
                          <button
                            block={!parameters.failureRedirect}
                            tabIndex={1}
                            type="submit"
                            id="submmit"
                            className="enter-myj"
                            disabled={!props.turnstileSuccess}
                          >
                            {translate("ButtonEnter")}
                          </button>
                        ) : (
                          <Progress animated color="danger" value={100} />
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <div style={{ margin: 'auto' }}>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </div>
        </Row>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
